<template>
  <div id="app">
    <mobile-suggester v-if="isLoggedIn"/>
    <loading-layout v-if="showLoadingLayout && loadingLayoutText" :loadingText="loadingLayoutText"/>
    <transition-group mode="out-in" name="slideDown" leave-active-class="fadeOut">
      <generic-modal v-if="modalComponent" :component="modalComponent" key="modal"/>
      <generic-notification
        key="notification"
        :type="notification.notificationType"s
        :text="notification.notificationText"
        v-if="hasNotification"
      />
    </transition-group>
    <logged-in-layout v-if="isLoggedIn"/>
    <logged-out-layout v-if="!isLoggedIn"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import LoggedInLayout from '@/components/shared/layouts/LoggedInLayout';
import LoggedOutLayout from '@/components/shared/layouts/LoggedOutLayout';
import MobileSuggester from '@/components/shared/layouts/MobileSuggester';
import Notification from '@/components/shared/notifications/Notification';
import GenericModal from '@/components/shared/modals/GenericModal';
import LoadingLayout from '@/components/shared/layouts/LoadingLayout';

export default {
  name: 'App',
  components: {
    'logged-in-layout': LoggedInLayout,
    'logged-out-layout': LoggedOutLayout,
    'generic-notification': Notification,
    'generic-modal': GenericModal,
    MobileSuggester,
    LoadingLayout,
  },
  data() {
    return {
      hasNotification: false,
      notification: undefined,
      modalComponent: undefined,
      showLoadingLayout: false,
      loadingLayoutText: undefined,
    };
  },
  computed: {
    ...mapGetters({
      loggedInUser: 'loggedInUser',
      previousUser: 'previousUser',
    }),
    isLoggedIn() {
      return this.loggedInUser != undefined;
    },
  },
  created() {
    this.$eventBus.onShowNotification(this, (payload) => {
      this.hasNotification = true;
      this.notification = payload;
      setTimeout(() => {
        this.$eventBus.hideNotification();
      }, 3000);
    });
    this.$eventBus.onHideNotification(this, (payload) => {
      this.hasNotification = false;
      this.notification = undefined;
    });
    this.$eventBus.onShowModal(this, (payload) => {
      this.modalComponent = payload;
    });
    this.$eventBus.onHideModal(this, (payload) => {
      this.modalComponent = undefined;
    });
    this.$eventBus.onShowLoading(this, (payload) => {
      this.loadingLayoutText = payload;
      this.showLoadingLayout = true;
    });
    this.$eventBus.onHideLoading(this, (payload) => {
      this.loadingLayoutText = undefined;
      this.showLoadingLayout = false;
    });
    if (this.isLoggedIn && !this.previousUser) {
      this.fetchCommonData(this.loggedInUser.partner_id);
      this.createUserAction({ id: this.loggedInUser.id, params: { action_type: 'page_load' } });
    }
  },
  mounted() {

  },
  methods: {
    ...mapActions({
      fetchCommonData: 'partners/fetchCommonData',
      createUserAction: 'users/createUserAction',
    }),
  },
};
</script>

<style lang="scss">
@import "assets/css/style.css";
@import "assets/css/tooltip.scss";
@import "vue2-animate/src/sass/vue2-animate.scss";
@import "vuejs-dialog/dist/vuejs-dialog.min.css";

html,
body {
  width: 100%;
  height: 100%;
  @media print {
    height: auto !important;

     a[href]:after {
        content: none;
    }
  }

  @media print,screen {

  .Header {
      display: none;
      }
  }


  h3, h6, .panel-title, th, h4, .header-text, .counter-anim {
    color: #000000 !important;
  }

  .counter-anim {
    font-weight: 500;
  }

  .control-label, .fixed-sidebar-left .side-nav li a, h6, .panel-title, th  {
    text-transform: none !important;
  }

  th {
    font-size: 14px !important;
  }

  .viewer-fullscreen {
    display: none;
  }
  .vuecal__cell {
    height: 130px;
  }

  .vuecal__event {
    cursor: pointer;
    background-color: rgba(255, 66, 0, 0.19);
    margin-bottom: 10px;
  }

  .vuecal__event.open {
    background-color: rgba(255,0,0, 0.19) ;
  }

  .vuecal__event.done {
    background-color: rgba(34, 175, 71, 0.19) ;
  }
  .vuecal__event.completed {
    background-color: rgba(34, 175, 71, 0.19) ;
  }
  .vuecal__cell-events {
    .vuecal__event {
      .vuecal__event-title {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 0.6rem;
      }
    }
  }

  .vuecal__time-cell {
    height: 60px;
  }

  .vuecal__menu button {
    border-bottom: none !important;
  }

  .vuecal__menu button.active {
    background: none;
  }

  .vuecal__cell {
    background: white;
  }

  // .vuecal__weekdays-headings {
  //   background: white;
  // }

}
#app {
  width: 100%;
  height: 100%;
  .page-wrapper {
    overflow-x: hidden;
    height: 100%;

    @media(max-width: 1024px) {
      padding: 85px 40px;
    }
  }
}

.slideDown-leave-active {
    transition: all .3s;
  }


.dg-btn dg-btn--cancel {
  background-color: red;
}

.date-picker-popup {
  .mx-datepicker-content {
    .mx-datepicker-body {
      .mx-calendar-panel-date {
        .mx-calendar-content {
          .mx-table {
            thead {
              tr {
                th {
                  text-align: center;
                }
              }
            }
            tbody {
              tr {
                .active {
                  background-color: var(--main-color);
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue